import React, { useState } from "react";
import "../Styles/MMG.css";
import SubscriberFormModal from "../components/SubscriberFormModal";
import { useNavigate } from "react-router-dom";


const MMG = () => {
  const [showSubscriberForm, setShowSubscriberForm] = useState(false);
  const navigate = useNavigate();

  return (
<div className="mmg-page">

<button className="back-button" onClick={() => navigate("/services")}>
  ← Back to Services
</button>


  <div className="header-container">
    <h2>💸 MMG+ Transactions</h2>
  </div>
  <p>
    RCS is the only MMG+ Superagent on Wakenaam. We offer subscriber Services (Deposits & Withdrawals)
    and Agent transfers.
  </p>
  <div className="mmg-section-wrapper">
  <div className="section-container">
    <h3>Transaction Types</h3>
    <div>
  <p>
    RCS makes it easy for subscribers, agents, and non-MMG account holders. We offer:
  </p>
  <ul className="mmg-bullet-list">
    <li>Wallet Recharge</li>
    <li>Wallet Withdrawal</li>
    <li>Agent Transfers</li>
    <li>Agent Vending</li>
    <li>Receiving for Non-Account Holders</li>
  </ul>
  <br /><br />
  Want to receive money from someone and do not have an mmg account? No problem just give them our details as follows:
  <br /><br />
  <ul className="mmg-bullet-list">
   <li><strong>RUPESH COYSILRAM +592 657 5756</strong></li>
   <li><strong>RUPESH COYSILRAM +592 662 7987</strong></li>
    </ul>

</div>

  </div>

  <div className="section-container">
    <h3>📝 MMG Sign Up</h3>
    <p>
      Want to become a registered MMG+ Agent or subscriber? Complete the sign-up process
      to start receiving and sending funds, or to make your agency active by increasing your customer foot traffic.
    </p>

    <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
    <div className="mmg-button-stack">
  <a
    href="https://www.mmg.gy/lead-generation/"
    target="_blank"
    rel="noopener noreferrer"
    className="agent-button"
  >
    Become an Agent
  </a>

  <button className="toggle-button" onClick={() => setShowSubscriberForm(true)}>
    Become a Subscriber
  </button>
</div>

</div>

  </div>
</div>

      {/* ✅ Subscriber Signup Modal */}
      {showSubscriberForm && (
        <SubscriberFormModal onClose={() => setShowSubscriberForm(false)} />
      )}


</div>


  );
};

export default MMG;
